var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 59.9949C120 76.5681 113.283 91.5668 102.416 102.425C91.5693 113.283 76.5616 120 60 120C26.8666 120 0 93.1413 0 59.9949C0 43.4319 6.71666 28.4332 17.5839 17.5752C28.4307 6.71722 43.4384 0 60 0C76.5616 0 91.5693 6.71722 102.416 17.5752C113.283 28.4332 120 43.4319 120 59.9949Z",
    fill: "url(#paint0_linear_5378_5442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0542 24.9158L51.1967 95.9322C50.3073 97.3636 48.2524 97.4352 47.271 96.0652L24.9742 64.8511C24.1768 63.7264 25.4751 62.3053 26.661 63.0005L47.7719 75.3819L92.9892 23.4026C94.0421 22.2166 95.8823 23.5765 95.0542 24.9158Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5378_5442",
    x1: 55.5,
    y1: -20,
    x2: 135.108,
    y2: 100.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/checkicon.4e9e877a90dff298ecf6cb1052b09092.svg";
export { ForwardRef as ReactComponent };